export default __webpack_public_path__ + "static/media/image-single-item.9d65a41b.png";